// Function to get bundle details
function getBundleDetails(bundleVariantId = null) {
  const bundles = BUNDLES;
  return bundleVariantId
    ? bundles.find((bundle) => bundle.id === Number(bundleVariantId))
    : bundles;
}

// Function to find matching items in the cart
function findMatchingItems(cartItems, bundleVariants) {
  let itemsToRemove = [];
  let foundAtLeastOne = false;

  for (const bundleVariant of bundleVariants) {
    const matchingItem = cartItems.find(
      (item) => item.variant_id === bundleVariant.id
    );
    if (matchingItem) {
      foundAtLeastOne = true;
      itemsToRemove.push({
        variantId: matchingItem.variant_id,
        lineItemId: matchingItem.id,
        quantityToRemove: Math.min(
          matchingItem.quantity,
          bundleVariant.quantity
        ),
        currentQuantity: matchingItem.quantity,
      });
    }
  }

  return { itemsToRemove, foundAtLeastOne };
}

// Function to check if items can be combined into a bundle
function canCombineIntoBundle(cartItems, bundleVariants) {
  let itemsToRemove = [];
  let canCombine = true;

  for (const bundleVariant of bundleVariants) {
    const matchingItem = cartItems.find(
      (item) => item.variant_id === bundleVariant.id
    );
    if (!matchingItem || matchingItem.quantity < bundleVariant.quantity) {
      canCombine = false;
      break;
    }
    itemsToRemove.push({
      variant_id: matchingItem.variant_id,
      quantityToRemove: bundleVariant.quantity,
      quantity: matchingItem.quantity,
    });
  }

  return { canCombine, itemsToRemove };
}

// Function to handle bundle addition to cart
function handleBundleAddToCart(bundleVariantId, isCartUpsell) {
  const bundleDetails = getBundleDetails(bundleVariantId);
  if (!bundleDetails) {
    console.error("Bundle details not found for ID:", bundleVariantId);
    return;
  }

  fetch(window.Shopify.routes.root + "cart.js")
    .then((response) => response.json())
    .then((cart) => {
      const { itemsToRemove, foundAtLeastOne } = findMatchingItems(
        cart.items,
        bundleDetails.variants
      );

      if (foundAtLeastOne) {
        removeItemsAndAddBundle(
          itemsToRemove,
          bundleVariantId,
          isCartUpsell
        );
      } else {
        addBundleItemToCart(bundleVariantId, 1);
      }
      initializeCrossSellSwiper()
    })
    .catch((error) =>
      console.error("Error handling bundle add to cart:", error)
    );
}

// Function to remove matching items and add the bundle
function removeItemsAndAddBundle(itemsToRemove, bundleId, isCartUpsell) {
  const updates = {};

  itemsToRemove.forEach((item) => {
    const newQuantity = Math.max(
      0,
      item.currentQuantity - item.quantityToRemove
    );
    updates[item.variantId] = newQuantity;
  });

  updates[bundleId] = (updates[bundleId] || 0) + 1;

  updateCart(updates, isCartUpsell);
}

// Function to check and combine items into bundles
function checkAndCombineIntoBundles() {
  fetch(window.Shopify.routes.root + "cart.js")
    .then((response) => response.json())
    .then((cart) => {
      const bundles = getBundleDetails();
      const updates = {};
      let bundlesAdded = false;

      bundles.forEach((bundle) => {
        const { canCombine, itemsToRemove } = canCombineIntoBundle(
          cart.items,
          bundle.variants
        );
        if (canCombine) {
          itemsToRemove.forEach((item) => {
            updates[item.variant_id] =
              (updates[item.variant_id] || item.quantity) -
              item.quantityToRemove;
          });
          updates[bundle.id] = (updates[bundle.id] || 0) + 1;
          bundlesAdded = true;
        }
      });

      if (bundlesAdded) {
        updateCart(updates);
      }
    })
    .catch((error) =>
      console.error("Error fetching cart for bundle check:", error)
    );
}
// Function to update the cart
function updateCart(updates, isCartUpsell = true) {
  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ updates }),
  })
    .then((response) => response.json())
    .then((updatedCart) => {
      document.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: { fromBundleScript: true },
        })
      );
      if(!isCartUpsell) document.querySelector('.cart-btn').click()
    })
    .catch((error) => console.error("Error updating cart:", error));
}

// Function to add a single item to cart
function addBundleItemToCart(variantId, quantity) {
  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      items: [{ id: variantId, quantity: quantity }],
    }),
  })
    .then((response) => response.json())
    .then((result) => {
      document.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: { fromBundleScript: true },
        })
      );
      document.querySelector('.cart-btn').click()
      checkAndCombineIntoBundles(); // Check for bundle combination after adding item
    })
    .catch((error) => console.error("Error adding item to cart:", error));
}

// Function to add a single cross-sell item to cart
function addCrossSellItemToCart(variantId, quantity) {
  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      items: [{ id: variantId, quantity: quantity }],
    }),
  })
    .then((response) => response.json())
    .then((result) => {
      document.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
        })
      );
    })
    .catch((error) => console.error("Error adding item to cart:", error));
}

// Function to check if a variant is a bundle
function isBundle(variantId) {
  const bundleVariantIds = BUNDLES.map(item => item.id);
  return bundleVariantIds.includes(Number(variantId));
}

// Initialize the script
function initBundleScript() {
  document.addEventListener("click", function (event) {
    const addToCartButton = event.target.closest("[data-product-variant-id]");
    const isCartUpsell = event.target.closest("[data-is-cart-upsell]") ? true : false;
    if (addToCartButton) {
      const variantId = addToCartButton.dataset.productVariantId;
      if (isBundle(variantId)) {
        event.preventDefault();
        handleBundleAddToCart(variantId, isCartUpsell);
      } else {
        document.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: { fromBundleScript: true },
          })
        );
      }
    }
  });

  document.addEventListener("cart:refresh", function (event) {
    // Add a delay before calling checkAndCombineIntoBundles
    setTimeout(() => {
      checkAndCombineIntoBundles();
    }, 500); // 500ms delay

    setTimeout(() => {
      initializeCrossSellSwiper();
    }, 1500)
  });
  // Initial check for bundles
  checkAndCombineIntoBundles();
}

document.addEventListener("cart:change", function(e) {
  setTimeout(() => {
    initializeCrossSellSwiper();
  }, 1500);
})

// Call the initialization function when the DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initBundleScript);
} else {
  initBundleScript();
  initializeCrossSellSwiper();
}



function waitForElm(selector) {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        observer.disconnect();
        resolve(document.querySelector(selector));
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

// Cross Sell functionality 
function initializeCrossSellSwiper() {
  waitForElm('.cart-drawer__cross-sell').then(element => {
    // Destroy existing Swiper instance if it exists
    if (element.swiper) {
      element.swiper.destroy(true, true);
    }
    // Read Swiper configuration from data attribute
    const config = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : {};
    // Initialize Swiper with the parsed configuration
    new Swiper(element, config);
  });
}